/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentDescriptionOnTeachersSubmissionsPageSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('ASSIGNMENT_DESCRIPTION_ON_TEACHERS_SUBMISSIONS_PAGE'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AssignmentDescriptionOnTeachersSubmissionsPageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentDescriptionOnTeachersSubmissionsPageSettingParser.decode(input).map(res => new AssignmentDescriptionOnTeachersSubmissionsPageSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentDescriptionOnTeachersSubmissionsPageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentDescriptionOnTeachersSubmissionsPageSettingParser.encode(data);
    }
    static schema() {
        return AssignmentDescriptionOnTeachersSubmissionsPageSettingParser.schema();
    }
}
